import { useTranslation } from "react-i18next";
import { startGoDoDesktopInstall } from "../../lib/start-godo-desktop-install";
import { hardwareFeatureLabel } from "../../lib/local-engine";
import { useLocalEngine } from "../../context/LocalEngineContext";

export function HardwareDesktopGate() {
  const { t, i18n } = useTranslation();
  const { gate, closeGate, refresh } = useLocalEngine();
  const lang = i18n.language.startsWith("ar") ? "ar" : "en";

  if (!gate.open || !gate.feature) return null;

  const featureLabel = hardwareFeatureLabel(gate.feature, lang);
  const isMobileBlock = gate.reason === "mobile";

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center bg-slate-900/55 p-4 backdrop-blur-sm"
      role="dialog"
      aria-modal="true"
      aria-labelledby="hardware-gate-title"
    >
      <div
        className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-6 shadow-2xl"
        dir={lang === "ar" ? "rtl" : "ltr"}
      >
        <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-amber-100 text-2xl">
          🖥️
        </div>
        <h2 id="hardware-gate-title" className="text-lg font-bold text-slate-900">
          {isMobileBlock
            ? t("local_engine.mobile_title", {
                defaultValue: "هذه الميزة تحتاج حاسوباً",
              })
            : t("local_engine.engine_offline_title", {
                defaultValue: "يلزم تثبيت مساعد سطح المكتب",
              })}
        </h2>
        <p className="mt-2 text-sm leading-relaxed text-slate-600">
          {isMobileBlock
            ? t("local_engine.mobile_body", {
                defaultValue:
                  "من الجوال يمكنك التقارير والإعدادات. أما {{feature}} فيحتاج فتح البرنامج على حاسوب Windows وتثبيت مساعد سطح المكتب مرة واحدة.",
                feature: featureLabel,
              })
            : t("local_engine.engine_offline_body", {
                defaultValue:
                  "لتشغيل {{feature}} على هذا الحاسوب: اضغط «تنزيل Install» ثم «فتح» من التحميلات — الباقي تلقائي.",
                feature: featureLabel,
              })}
        </p>

        <div className="mt-6 flex flex-wrap gap-2">
          {!isMobileBlock && (
            <button
              type="button"
              className="erp-btn erp-btn-primary text-base px-5 py-2.5"
              onClick={() => {
                void startGoDoDesktopInstall(window.location.origin).finally(() => closeGate());
              }}
            >
              {t("local_engine.install_btn", { defaultValue: "تنزيل Install" })}
            </button>
          )}
          <button type="button" className="erp-btn" onClick={() => void refresh({ forceDiscover: true })}>
            {t("local_engine.recheck", { defaultValue: "إعادة فحص" })}
          </button>
          <button type="button" className="erp-btn erp-btn-ghost" onClick={closeGate}>
            {t("common.close", { defaultValue: "إغلاق" })}
          </button>
        </div>
      </div>
    </div>
  );
}
